"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDate = isDate;
exports.formatTime = formatTime;

function isDate(time) {
  return time instanceof Date;
}
/**
 * 格式化时间
 * @param {Date} time
 * @param {*} pattern eg: YYYY-MM-DD HH:mm:ss
 */


function formatTime(time) {
  var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

  if (!isDate(time)) {
    // REVIEW 假定传入数据不是Date就是时间戳
    time = new Date(time);
  }

  var year = time.getFullYear();
  var month = "00".concat(time.getMonth() + 1).slice(-2);
  var day = "00".concat(time.getDate()).slice(-2);
  var hour = "00".concat(time.getHours()).slice(-2);
  var min = "00".concat(time.getMinutes()).slice(-2);
  var sec = "00".concat(time.getSeconds()).slice(-2);
  return pattern.replace('YYYY', year).replace('MM', month).replace('DD', day).replace('HH', hour).replace('mm', min).replace('ss', sec);
}